module.exports = __webpack_public_path__ + "texto-neumomed.svg?9bb04d48b3e7e557f293e95c36a178f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/texto-neumomed.svg
// module id = 1200
// module chunks = 0